import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import FilterSidebar from "../components/ProfessorDashboard/FilterSidebar";
import MainContent from "../components/ProfessorDashboard/MainContent";
import ContactModal from "../components/ContactModal/ContactModal";
import styles from "../components/ProfessorDashboard/ProfessorDashboard.module.css";
import logger from "../utils/logger";

export default function ProfessorDashboard() {
  const [students, setStudents] = useState([]);
  const [filters, setFilters] = useState({
    name: "",
    interests: "",
    institutions: [],
    gpa: [0, 100],
    fields: [],
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalStudents, setTotalStudents] = useState(0);
  const [viewMode, setViewMode] = useState("card");
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const pageSize = 12;

  const fetchStudents = useCallback(async () => {
    try {
      const query = new URLSearchParams();
      query.append("role", "student");

      if (filters.name?.trim()) {
        query.append("name", filters.name.trim());
      }
      if (filters.interests?.trim()) {
        query.append("interests", filters.interests.trim());
      }
      if (filters.gpa?.[0] !== undefined) {
        query.append("gpaMin", filters.gpa[0]);
      }
      if (filters.gpa?.[1] !== undefined) {
        query.append("gpaMax", filters.gpa[1]);
      }

      query.append("page", currentPage);
      query.append("limit", pageSize);

      filters.institutions?.forEach((inst) => {
        if (inst?.trim()) query.append("institutions", inst);
      });
      filters.fields?.forEach((field) => {
        if (field?.trim()) query.append("fields", field);
      });
      filters.preferredCountries?.forEach((country) => {
        if (country?.trim()) query.append("preferredCountries", country);
      });

      logger.log("Requesting students data...");
      const token = localStorage.getItem("token");
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/users?${query.toString()}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // SECURITY: Removed sensitive student data logging
      logger.log("Students data loaded successfully");

      setStudents(res.data.users);
      setTotalPages(res.data.totalPages);
      setTotalStudents(res.data.total);
    } catch (err) {
      console.error("Error fetching students:", err);
    }
  }, [filters, currentPage]);

  useEffect(() => {
    fetchStudents();
  }, [fetchStudents]);

  const handleFilterChange = useCallback((newFilters) => {
    setFilters(newFilters);
    setCurrentPage(1);
  }, []);

  const handleStudentView = (student) => {};

  const handleToggleSave = (studentId) => {};

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  return (
    <div className={styles.dashboardContainer}>
      <FilterSidebar onFilterChange={handleFilterChange} />

      <MainContent
        students={students}
        viewMode={viewMode}
        onViewModeChange={setViewMode}
        totalPages={totalPages}
        totalStudents={totalStudents}
        currentPage={currentPage}
        pageSize={pageSize}
        onPageChange={handlePageChange}
        onStudentView={handleStudentView}
        onToggleSave={handleToggleSave}
        onStudentContact={(student) => {
          setSelectedStudent(student);
          setIsModalOpen(true);
        }}
      />

      {/* Contact Modal */}
      <ContactModal
        professor={selectedStudent}
        isOpen={isModalOpen}
        onClose={() => {
          setIsModalOpen(false);
          setSelectedStudent(null);
        }}
        onMessageSent={() => {
          console.log("Message sent successfully");
        }}
      />
    </div>
  );
}
